import { render, staticRenderFns } from "./AllocationMobileViewTabs.vue?vue&type=template&id=79e6355c"
import script from "./AllocationMobileViewTabs.vue?vue&type=script&lang=js"
export * from "./AllocationMobileViewTabs.vue?vue&type=script&lang=js"
import style0 from "./AllocationMobileViewTabs.vue?vue&type=style&index=0&id=79e6355c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports